// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Standard session start & stop event names
export const SESSION_START_EVENT = '_session.start';
export const SESSION_STOP_EVENT = '_session.stop';
